export const roiActionConstants = {
  ADD_ROI_AREA_CITY_DATA_FOR_COUNTY: "ADD_ROI_AREA_CITY_DATA_FOR_COUNTY", //roi
  ADD_SELECTED_AREA: "ADD_SELECTED_AREA", //roi
  SET_ROI_ENLARGE_VIEW: "SET_ROI_ENLARGE_VIEW", //roi
  INIT_ROI_OPEN_ACCESS_VIEW: "INIT_ROI_OPEN_ACCESS_VIEW", //roi
  DELETE_SELECTED_AREA: "DELETE_SELECTED_AREA", //roi
  HANDLE_ROI_AREA_ALLOCATION_RESPONSE: "HANDLE_ROI_AREA_ALLOCATION_RESPONSE", //roi
  SET_ROI_AREA_INTERVEL_ID: "SET_ROI_AREA_INTERVEL_ID", // roi
  HAS_ROI_ALLOCATION_INITIALIZED: "HAS_ROI_ALLOCATION_INITIALIZED", // roi
  SET_ROI_COUNTIES: "SET_ROI_COUNTIES", // roi
};
